export default {

  namespaced: true,

  state: () => ({
    
    lastRoute : null
    
  }),

  mutations: {
    setLastRoute(state, from) {
      state.lastRoute = from
    }
  },

  actions: {

  }
}
